import API from "../../../utils/api";


export const getWhyYouLoveItApi = async (filters) => {
    const response = await API.get(`settings/why-you-love-it`, { params: filters });
    return { response };
};

export const addWhyYouLoveItApi = async (data) => {
    const response = await API.post(`settings/why-you-love-it`, data, { "content-type": "multipart/form-data" });
    return { response };
};

export const updateWhyYouLoveItApi = async (data, id) => {
    const response = await API.post(`settings/why-you-love-it/${id}`, data, { "content-type": "multipart/form-data" });
    return { response };
}

export const deleteWhyYouLoveItApi = async (id) => {
    const response = await API.delete(`settings/why-you-love-it/${id}`);
    return { response };
}
